import { render, staticRenderFns } from "./ItemCategoryView.vue?vue&type=template&id=2ed0a6be&"
import script from "./ItemCategoryView.vue?vue&type=script&lang=js&"
export * from "./ItemCategoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports